export default {
  methods: {
    waitForElementToScroll(elementId) {
      const targetDiv = document.getElementById(elementId);

      if (!targetDiv) {
        const observer = new MutationObserver((mutationsList, observer) => {
          for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
              const targetDiv = document.getElementById(elementId);
              if (targetDiv) {
                targetDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
                observer.disconnect(); // Stop observing once the target element is found
                break;
              }
            }
          }
        });

        observer.observe(document.body, { childList: true, subtree: true });
      } else {
        targetDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }
};
